var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var SessionInformationController = {
    /*****************************************************************************************************
        * Is using route "api/{groupId}/session/information" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @returns {SessionInformationDownloadDto[]}
    ******************************************************************************************************/
    GetInformations: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/{groupId}/session/information", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/{groupId}/session/information/paged" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {SessionInformationDirection} direction
        * @param {number} count
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<SessionInformationDownloadDto, string>}
    ******************************************************************************************************/
    GetPaged: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        var fd = new FormData();
        if (data.direction !== undefined)
            fd.append("direction", JSON.stringify(data.direction));
        if (data.count !== undefined)
            fd.append("count", JSON.stringify(data.count));
        if (data.token !== undefined)
            fd.append("token", JSON.stringify(data.token));
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/{groupId}/session/information/paged", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/session/information/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {SessionInformationDownloadDto}
    ******************************************************************************************************/
    GetInformation: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/session/information/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/{groupId}/session/information/search" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} query
        * @param {string} queryLng
        * @param {SessionInformationDirection} direction
        * @returns {SessionInformationDownloadDto[]}
    ******************************************************************************************************/
    SearchInformation: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        var fd = new FormData();
        fd.append("query", JSON.stringify(data.query));
        fd.append("queryLng", JSON.stringify(data.queryLng));
        if (data.direction !== undefined)
            fd.append("direction", JSON.stringify(data.direction));
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/{groupId}/session/information/search", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/{groupId}/session/information" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {SessionInformationUploadDto} dto
        * @returns {SessionInformationDownloadDto}
    ******************************************************************************************************/
    CreateInformation: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/{groupId}/session/information", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/session/information/{id}" and http method "PUT" to call the back-end.
    
        * @param {string} id
        * @param {SessionInformationUploadDto} dto
        * @returns {SessionInformationDownloadDto}
    ******************************************************************************************************/
    UpdateInformation: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/session/information/{id}", __assign({}, data)),
            method: "PUT",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/session/information/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    DeleteInformation: function (data, onSuccess, onError, onProgress, mutex) {
        var _a;
        (_a = CollaborationServiceSetup.clientCore) === null || _a === void 0 ? void 0 : _a.call({
            uri: RouteFiller("api/session/information/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=SessionInformationController.js.map